import * as Sentry from '@sentry/react';
import { setSandboxErrorHandler } from '@trinity/chat-components/components/Sandbox';
import { createMaskedReplayIntegration, createSentryBaseOptions } from '@trinity/react-utils/sentry';
import { config } from '@/config';

// Sentry is optional here: session replay (which only Sentry offers) and an extra copy of error reports. Tracing and
// the primary error reports are OpenTelemetry (see ./telemetry), so there is no browser tracing, header propagation
// or router instrumentation in this init.
Sentry.init({
  ...createSentryBaseOptions({
    dsn: config().SENTRY_DSN,
    enabled: config().SENTRY_ENABLED,
    environment: config().APP_ENVIRONMENT,
    release: config().SENTRY_RELEASE,
    app: 'chat',
    platform: config().APP_PLATFORM,
    tracesSampleRate: undefined,
  }),
  integrations: [
    Sentry.dedupeIntegration(),
    createMaskedReplayIntegration(),
    config().APP_PLATFORM === 'veeva' &&
      Sentry.captureConsoleIntegration({
        levels: ['error'],
      }),
  ].filter(Boolean),
});

// Route sandbox (code widget) errors to Sentry so they appear in dashboards
// alongside regular app errors. The `source` tag distinguishes infrastructure
// failures (bundler crash) from user-authored JSX runtime errors.
setSandboxErrorHandler((error, context) => {
  Sentry.captureException(error, {
    tags: { sandbox_error_source: context.source },
    extra: { message: context.message },
  });
});
